import React, {useEffect} from "react";
import ReactDOM from "react-dom";
import AddToWishlistButton from "./AddToWishlistButton";

const AddToWishlistButtonPortal: React.FC<{root: HTMLElement | null; targetNode: HTMLDivElement | null}> = ({
  root,
  targetNode,
}) => {
  useEffect(() => {
    if (!targetNode || !root) {
      return;
    }
    root.dataset.itemId = targetNode.dataset.itemId;
    targetNode.replaceWith(root);
  }, []);

  if (!targetNode || !root) {
    return null;
  }

  const itemId = Number(targetNode.dataset.itemId ?? "0");

  if (itemId === 0) {
    return null;
  }

  return ReactDOM.createPortal(
    <AddToWishlistButton itemId={itemId} showAsText={targetNode.className.includes("wholewidth")} />,
    root,
  );
};

export default AddToWishlistButtonPortal;
